import {h, Fragment} from "preact"
import { RangeSlider, useRangeSlider } from '@nosto/preact';
import RangeInput from './elements/RangeInput';
import Icon from './elements/Icon';
import { ArrowIcon } from './elements/Icons';

export default function RangeFacet({ facet, isActive, setActive }) {
  const { min, max, range, updateRange } = useRangeSlider(facet.id);
  const isSelected = min !== range[0] || max !== range[1];
  // const [active, setActive] = useState(isSelected);

  return (
    <li
      class={`ns-sidebar-dropdown ns-flex-fill ${
        isActive ? 'ns-active' : ''
      } ns-relative`}
    >
      <a
        class="gc_ft_title ns-relative ns-w-100 ns-border-box ns-text-undecorated "
        href="javascript:void(0)"
        onClick={() => {
          setActive(!isActive);
        }}
      >
        <span class="gc_facet--title">{facet.name}</span>
        {/* {isSelected && (
          <span class="ns-total-count ns-d-inline-block ns-text-align-center ns-font-3 ns-font-bold ns-color-white ns-background-primary ns-ml-1">
            {1}
          </span>
        )} */}
        {/* <Icon
          name="arrow"
          className="ns-absolute"
        /> */}
        <ArrowIcon active={isActive} />
      </a>
      <div class="ns-sidebar-submenu ns-d-none facets-wrapper">
        <div class="price-wrap nsc-price-wrap">
          <div class="price-wrap-min">
            <label
              for={`ns-${facet.id}-min`}
              // class="ns-form-label"
            >
              {/* Min. */}
            </label>
            <RangeInput
              id={`ns-${facet.id}-min`}
              min={min}
              max={max}
              range={range}
              value={range[0]}
              onChange={(e) => {
                const value = parseFloat(e.currentTarget.value) || undefined;
                updateRange([value, range[1]]);
              }}
            />
          </div>
          <div class="price-wrap_line">-</div>
          <div class="price-wrap-max">
            <label
              for={`ns-${facet.id}-max`}
              // class="ns-form-label"
            >
              {/* Max. */}
            </label>
            <RangeInput
              id={`ns-${facet.id}-max`}
              min={min}
              max={max}
              range={range}
              value={range[1]}
              onChange={(e) => {
                const value = parseFloat(e.currentTarget.value) || undefined;
                updateRange([range[0], value]);
              }}
            />
          </div>
        </div>

        <div class="ns-relative">
          <RangeSlider id={facet.id} />
          <span class="ns-absolute nsc-range-slider nsc-range-slider--min">{min}</span>
          <span class="ns-absolute nsc-range-slider nsc-range-slider--quarter">{max * 0.25}</span>
          <span class="ns-absolute nsc-range-slider nsc-range-slider--middle">{max * 0.5}</span>
          <span class="ns-absolute nsc-range-slider nsc-range-slider--three-quarters">{max * 0.75}</span>
          <span class="ns-absolute nsc-range-slider nsc-range-slider--max">{max}</span>
        </div>
      </div>
    </li>
  );
}
